"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { FilterCmsOptionType } from "../../types/filter-cms.type";

type FilterTrueFalseProps = FilterCmsOptionType;

export const FilterTrueFalseAutoupdate = ({
  label,
  paramName,
}: FilterTrueFalseProps) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const handleSwitch = (checked: boolean) => {
    const params = new URLSearchParams(searchParams);
    if (checked) {
      params.set(paramName, "true");
    } else {
      params.delete(paramName);
    }
    params.delete("page");
    replace(`${pathname}?${params.toString()}`, { scroll: false });
  };

  return (
    <div className="my-2 flex items-center justify-between space-x-4 rounded-lg bg-white p-4">
      <Label className="font-base font-normal leading-5" htmlFor={paramName}>
        {label}
      </Label>
      <Switch
        className="h-[30px] w-[50px] data-[state=checked]:bg-brand-green-300 [&>span]:h-7 [&>span]:w-7"
        id={paramName}
        checked={searchParams.get(paramName) ? true : false}
        onCheckedChange={handleSwitch}
      />
    </div>
  );
};
